import { Box, Stack, Paper, Table, TableBody, TableContainer, TableHead, TableRow } from '@mui/material';
import StyledTableRow from '../shared/components/styledTableRow';
import StyledTableCell from '../shared/components/styledTableCell';
import { GetDateOnlyStringValue, GetDayJSValueFromUTCDate, GetNoToCurrencyFormat } from '../utils/extensions/functionEx';

export default function ServiceReminder(props) {

    const { dbPatientServices } = props;

    return (
        <Box sx={{ bgcolor: '#cfe8fc', padding: '8px, 0' }}>
            <Stack spacing={0}>
                <TableContainer component={Paper} sx={{ maxHeight: `calc(100vh - 185px)`, borderRadius: '0' }}>
                    <Table stickyHeader sx={{ minWidth: 700, width: '2930px', overflowX: 'auto' }}>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell sx={{ width: '150px' }}>Duty</StyledTableCell>
                                <StyledTableCell sx={{ width: '200px' }}>Nurse</StyledTableCell>
                                <StyledTableCell sx={{ width: '70px' }}>Duty Days</StyledTableCell>
                                <StyledTableCell sx={{ width: '100px' }}>Start Date</StyledTableCell>
                                <StyledTableCell sx={{ width: '100px' }}>End Date</StyledTableCell>
                                <StyledTableCell sx={{ width: '100px' }}>Completed Days</StyledTableCell>
                                <StyledTableCell sx={{ width: '100px' }}>Salary</StyledTableCell>
                                <StyledTableCell sx={{ width: '100px' }}>Paid</StyledTableCell>
                                <StyledTableCell sx={{ width: '100px' }}>Balance</StyledTableCell>
                                <StyledTableCell sx={{ width: '220px' }}>Patient</StyledTableCell>
                                <StyledTableCell sx={{ width: '190px' }}>Place</StyledTableCell>
                                <StyledTableCell sx={{ width: '200px' }}>Nurse Phone</StyledTableCell>
                                <StyledTableCell sx={{ width: '200px' }}>Patient Phone</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {dbPatientServices.map((dbPatientService) => (
                                <StyledTableRow key={dbPatientService.service_nurse_id.toString()}>
                                    <StyledTableCell>
                                        {dbPatientService.service_type_name}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {dbPatientService.nurse_name}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {dbPatientService.nurse_duty_days}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {GetDateOnlyStringValue(GetDayJSValueFromUTCDate(dbPatientService.nurse_start_date))}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {GetDateOnlyStringValue(GetDayJSValueFromUTCDate(dbPatientService.nurse_end_date))}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {dbPatientService.nurse_completed_days}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {GetNoToCurrencyFormat(dbPatientService.service_fee)}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {GetNoToCurrencyFormat(dbPatientService.service_paid_fee)}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {GetNoToCurrencyFormat(dbPatientService.service_balance_fee)}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {dbPatientService.patient_name}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {dbPatientService.place}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {dbPatientService.nurse_phone}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {dbPatientService.patient_phone}
                                    </StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Stack>
        </Box>
    );
}